<template>
  <div id="footer" class="footer">
    <p>外语教学与研究出版社  基础教育数字中心</p>
    <p>地址：西三环北路19号外研社大厦  电话：400-898-7008  邮箱：k12service@unipus.cn</p>
  </div>
</template>

<script>
export default {
  name: 'footer-main',
  computed: {

  }
}
</script>

<style lang="scss" scoped>
@import '@/common/styles/variables.scss';
.footer{
  color: $theme-main-color;
  text-align: center;
  height: $footer-height;
}
</style>



// WEBPACK FOOTER //
// src/components/Layout/components/Footer.vue